import { setToken } from "@/utils/auth";
import { countryCurrencyList } from "@/config/countryCurrency";
import { responsiveStorageNameSpace } from "@/config";
import { storageLocal } from "@pureadmin/utils";
import { i18n } from "@/plugins/i18n";

export const RECHARGE_H5_PATH = "/h5/recharge";

/** 国家码 -> 界面语言 */
const COUNTRY_LOCALE_MAP: Record<string, string> = {
  CN: "zh-CN",
  VN: "vi-VN",
  TH: "th-TH",
  PH: "en-US",
  MY: "ms-MY",
  ID: "id-ID",
  JP: "ja-JP",
  US: "en-US"
};

export function normalizeCountryCode(country?: string | null): string | null {
  if (!country || typeof country !== "string") return null;
  const code = country.trim().toUpperCase();
  return code || null;
}

export function isSupportedCountryCode(countryCode: string): boolean {
  return countryCurrencyList.some(item => item.code === countryCode);
}

export function countryCodeToLocale(countryCode: string): string {
  return COUNTRY_LOCALE_MAP[countryCode] || "en-US";
}

/** 切换界面语言（写入 storage 并同步 i18n） */
export function applyRechargeH5Locale(countryCode: string): string {
  const locale = countryCodeToLocale(countryCode);
  storageLocal().setItem(`${responsiveStorageNameSpace()}locale`, { locale });
  if (i18n.global.locale && typeof i18n.global.locale === "object") {
    (i18n.global.locale as { value: string }).value = locale;
  }
  return locale;
}

function readQueryValue(value: unknown): string | null {
  if (typeof value === "string" && value.trim()) return value.trim();
  if (Array.isArray(value) && value[0]) return String(value[0]).trim();
  return null;
}

/** 从 query 读取 token（支持 token / accessToken） */
export function extractRechargeH5Token(
  query: Record<string, unknown>
): string | null {
  return readQueryValue(query.token ?? query.accessToken);
}

/** 从 query 读取国家（支持 country / countryCode） */
export function extractRechargeH5Country(
  query: Record<string, unknown>
): string | null {
  return normalizeCountryCode(
    readQueryValue(query.country ?? query.countryCode)
  );
}

/** 将外部传入 token 写入本地，避免路由守卫跳转登录页 */
export function applyRechargeH5Token(
  query: Record<string, unknown>
): boolean {
  const token = extractRechargeH5Token(query);
  if (!token) return false;

  setToken({
    accessToken: token,
    refreshToken: token,
    expires: Date.now() + 30 * 24 * 60 * 60 * 1000
  });
  return true;
}
